import { CREATE_OR_UPDATE_QUOTE } from './createOrUpdateQuote';
import { GET_QUOTE_BY_VO_ID } from './getQuoteByVOId';

export const quoteAPI = {
  getQuote: GET_QUOTE_BY_VO_ID,
  upsertQuote: CREATE_OR_UPDATE_QUOTE,
};
